const normalizeBase = (url) => (url || "").replace(/\/$/, "");

const servicesBase = normalizeBase(process.env.REACT_APP_SERVICES_BASE_URL);

export const enterpriseApiUrl = `${servicesBase}/enterprise/api/v1/`;
export const enterpriseUserUrl = `${servicesBase}/enterprise/api/v1/enterprise-user`;
export const atsApiUrl = `${servicesBase}/ats/api/v1/`;
export const authApiUrl = `${servicesBase}/auth-ts/api/v1`;
export const atsPublicApiUrl = `${servicesBase}/ats/api/v1/public/`;
export const enterprisePublicApiUrl = `${servicesBase}/enterprise/api/v1/public/`;
